import React from "react";

import { ImageProvider } from "../../../utils/image-provider";
const TravelSec = ({ data }) => {
  const card = data.cards;
  return (
    <section className="container-fluid bg-[#E6EAEF]" id="airportSection">
      <div className="container">
        <div className="gird grid-cols-1 py-[1.56vw] mx-auto text-center">
          <h2
            className="text-center text-[4.7vw] md:text-[2.38vw] font-redhatMedium mb-[1.0vw]"
            style={{ color: data.heading_color }}
          >
            {data.heading}
          </h2>
          <p
            style={{ color: data.heading_color }}
            className="text-center text-[3.9vw] md:text-[1.35vw] font-redhatMedium"
          >
            {data?.description?.data?.description}
          </p>
        </div>
        <div className="grid md:grid-cols-3 mx-auto ">
          {card.map((section, index) => (
            <div
              key={index}
              className=" p-[0.5vw] flex flex-col items-center text-center"
            >
              <div className="flex justify-center travelImg">
                <ImageProvider
                  className="rounded-10vw-radius"
                  Image={section?.card_image}
                  alt=""
                  tailwindStyle={
                    "w-[52.44vw]  md:w-[26.44vw] object-contain borderRradius"
                  }
                />
              </div>
              <div className="decsrption  p-[1.4vw] ">
                <h3
                  className="text-[5.7vw] md:text-[1.59vw] font-redhatMedium "
                  style={{ color: section.heading_color }}
                >
                  {section.heading}
                </h3>
                <p
                  style={{ color: section.heading_color }}
                  className="text-[3.5vw] md:text-[0.95vw]  font-redhatRegular pt-[0.5
                  vw]"
                >
                  {section.description?.data?.description || ""}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TravelSec;
